import { render } from "./TermsOfUsePage.vue?vue&type=template&id=34f332f2"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__